import { useModalView } from "components/ModalView";
import { ActionBar } from "components/TitleBar/ActionBar";
import { useNavigate } from "react-router";

interface IProps {
  hideMore?: boolean;
}
function KycTitle({ hideMore }: IProps) {
  const navigate = useNavigate();
  const { hasPrev, currentView, onPrev } = useModalView();

  const handleBack = () => {
    if (!hasPrev && currentView === 0) return navigate(-1);
    else return onPrev();
  };

  return (
    <ActionBar hideMore={hideMore} title="Identity Verification" onBackClick={handleBack}>
      {/* This is your first time using Bitmama and so we would like to get to know you better and verify your identity. Once done,
        you won’t have to do this again anytime you use our platform */}
      Let's get to know you and verify your identity
    </ActionBar>
  );
}

export default KycTitle;
